// @NOTE this way to set the styles no longer works for components,
// since material changed the way it handles disabled and errored states
// If we need to support light and dark colors/background for texts we'll need to handle
// dark and light themes, and render components on the theme context. I'm patching fow now,
// to avoid showing orange colors to our users. But this is far from the best/correct solution.
import { reskinStyles, THEME_VARIANTS } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  'light-textFieldRoot': {
    backgroundColor: theme.colors.text_secondary_background,
    '&.Mui-error': {
      border: `1px solid ${theme.colorPalette.red_50}`,
      '& input': {
        color: theme.colorPalette.red_50
      }
    }
  },
  'light-textFieldInput': {
    color: theme.colors.text_secondary,
    ...reskinStyles(theme, { color: theme.colorPalette.green_100 })
  },
  'light-textFieldDisabled': {
    color: `${theme.colorPalette.green_75} !important`,
    '&.Mui-error': {
      '& input': {
        color: `${theme.colorPalette.red_50} !important`
      }
    }
  },
  'light-labelRoot': {
    color: theme.colors.text_disabled,
    zIndex: 1,
    ...reskinStyles(theme, { color: theme.colors.text_secondary })
  },
  'light-labelShrink': {
    color: theme.colors.text_secondary,
    zIndex: 1
  },
  'light-labelDisabled': {
    color: `${theme.colors.text_secondary} !important`
  },
  'light-labelFocused': {
    color: `${theme.colors.text_secondary} !important`,
    ...reskinStyles(theme, { color: `${theme.colorPalette.orange_50} !important` })
  },
  'light-textFieldError': {
    border: `1px solid ${theme.colors.error} !important`,
    borderRadius: theme.themeVariant === THEME_VARIANTS.RESKIN ? 23 : theme.spacing(1),
    boxShadow: 'none !important',
    '& textarea': {
      border: 'none !important',
      outline: 'none !important',
      boxShadow: 'none !important'
    }
  },
  'light-labelError': {
    color: `${theme.colors.error} !important`
  },
  'dark-labelRoot': {
    minWidth: 195
  },
  'dark-textFieldDisabled': {
    color: `${theme.onCard.white} !important`
  },
  'dark-labelDisabled': {
    color: `${theme.onCard.white} !important`
  },
  'dark-formHelperRoot': {
    color: theme.onCard.white
  },
  // MUI's disabled helper color (`.MuiFormHelperText-root.Mui-disabled`) outranks the root class, which
  // left a locked dark field's hint dark grey on the dark card (#37787).
  // An error on a disabled field keeps MUI's error red.
  'dark-formHelperDisabled': {
    '&:not(.Mui-error)': {
      color: `${theme.colorPalette.white} !important`
    }
  },
  'red-labelShrink': {
    color: theme.colorPalette.white
  },
  'red-textFieldRoot': {
    backgroundColor: theme.colors.white
  },
  'red-textFieldInput': {
    color: theme.colors.text_secondary,
    zIndex: 2
  }
});

export default styles;
